import React, { useState } from 'react';
import AuthContext from './auth-context';

import request from '../../config/axios';

const AuthState = (props) => {

  const [ isLoggedIn, setIsLoggedIn ] = useState({
    isAuthenticated: false
  });

  const loginUser = async (formData) => {
    // const config = {
    //   headers: {'Content-Type': 'application/json'}
    // }
    const WORDPRESS_REST_API = 'https://app.paulmfitness.com:8890/wp-json';
    try {
      await request.post(`/oauth/authorize?response_type=${formData.response_type}&client_id=${formData.client_id}&redirect_uri=${formData.redirect_uri}`);
      console.log('POST REQUEST', request);
    } catch (err) {
      console.log('CATCH ERROR', err);
    }
  };

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn: isLoggedIn,
        loginUser
      }}>
      { props.children }
    </AuthContext.Provider>
  );

}

export default AuthState;